module.exports = __webpack_public_path__ + "img/whatsapp-by-using.1c15a317.webp";